<template>
  <div id="app">
    <v-header class="header"></v-header>
    <transition tag="main"  name="slide-up" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Vue from 'vue'

export default {
  name: 'App',
  components: {
    'v-header' : Header
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue